import Vue from "vue";
import { firestore } from "@/firebase"
import { splitPath } from "../helpers.js";
import { FETCH } from "./helpers/action.type.js";

export default {
  namespaced: true,
  state: {
    default: {}
  },
  getters: {
    template: state => id => state[id],
    template_item_ids: (state, getters) => id => {
      const categories = getters.template(id).categories;
      const item_ids = [];
      Object.keys(categories).forEach(cat => {
        const items = categories[cat].items;
        Object.keys(items).forEach(item => {
          item_ids.push(`/${id}/${cat}/${item}`);
        });
      });
      return item_ids;
    },
    collection: () => firestore.collection("/templates"),
    stored: state => id => id in state && Object.keys(state[id]).length > 0,
    at: state => path => {
      const parts = splitPath(path);
      let obj = state;
      for (const part of parts) obj = obj[part];
      return obj;
    },
    items: state => path => {
      const parts = splitPath(path);
      const template = state[parts[0]];
      const items = [];
      if (parts.length === 1) {
        for (const cat_id in template.categories) {
          const cat = template.categories[cat_id];
          for (const item_id in cat.items) {
            const item = cat.items[item_id];
            items.push({
              name: item.name,
              path: `${template.name}/${cat.name}/${item.name}`,
              category_color: cat.color,
              grade_color: cat.grade_color,
              goal_color: cat.goal_color
            });
          }
        }
      } else if (parts.length === 2) {
        const cat = template.categories[parts[1]];
        for (const item_id in state[parts[0]].categories[parts[1]].items) {
          const item = cat.items[item_id];
          items.push({
            name: cat.name,
            path: `${template.name}/${cat.name}/${item.name}`,
            category_color: cat.color,
            grade_color: cat.grade_color,
            goal_color: cat.goal_color
          });
        }
      } else if (parts.length === 3) {
        const cat = template.categories[parts[1]];
        const item = cat.items[parts[2]];
        items.push({
          name: item.name,
          path: `${template.name}/${cat.name}/${item.name}`,
          category_color: cat.color,
          grade_color: cat.grade_color,
          goal_color: cat.goal_color
        });
      } else console.error("Path " + path + " is not supported.");
      
      return items;
    }
  },
  mutations: {
    /**
     * Sets the template data in the state.
     * @param {Object} payload - The payload with all of the data.
     * @param {string} payload.id - The template id.subscribers
     * @param {function(): *} payload.data - Must return the data in the template doc.
     */
    set(state, payload)  {
      if (payload.id in state) {
        state[payload.id] = {
          id: payload.id,
          ...payload.data()
        };
      } else {
        Vue.set(state, payload.id, {
          id: payload.id,
          ...payload.data()
        });
      }
    }
  },
  actions: {
    async fetch({ commit, getters }, id) {
      const doc = await getters.collection.doc(id).get();
      commit("set", doc);
      return doc;
    },
    async get({ dispatch, getters }, payload) {
      if (!payload?.path) {
        console.warn("Attempted to get a template, but didn't specify wich one.");
        return null;
      }

      const [phead] = splitPath(payload.path);
      if (getters.stored(phead)) {
        return getters.at(payload.path);
      } else {
        await dispatch(FETCH, phead);
        return getters.at(payload.path);
      }
    },
    async cache({ dispatch }, payload) {
      await dispatch("get", payload);
    }
  }
}